import Vue from 'vue'
import vuex from 'vuex'
import permission from './modules/permission'

Vue.use(vuex)
export default new vuex.Store({
	state:{
		collapseStatus:false,
		userShow:false,
	},
	mutations:{
		getCollapse(state,data){
			state.collapseStatus=data
		},
		changePasswordShow(state,data){
			state.userShow=data
		},
	},
	modules: {
		permission
	}
})


// WEBPACK FOOTER //
// ./src/store/index.js